export enum MetricType {
  Basic = 'Basic',
  Pointer = 'Pointer',
  Percentage = 'Percentage',
}
